import { baseApi, Http, rtkq, RtkqRequest } from '@app/base';
import {
  CreateDocumentTagRequest,
  DocumentTag,
  UpdateDocumentTagRequest,
} from './documentTagsTypes';
import { GetDocumentTagsDocument } from './graphql';
import { FilterRule, PagingRule, SortRule } from '@webinex/asky';

export const documentTagsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDocumentTagList: build.query<
      DocumentTag[],
      RtkqRequest<{
        filterRule?: FilterRule;
        sortRule?: SortRule;
        pagingRule?: PagingRule;
      }>
    >({
      queryFn: rtkq.graphql(GetDocumentTagsDocument, {
        select: (x) => x.documentTags as DocumentTag[],
        vars: (query) => ({
          query: JSON.stringify(query) ?? null,
        }),
      }),
      providesTags: (result = []) => [
        { type: 'main:document-tag', id: 'list' },
        ...(result.map(({ id }) => ({ type: 'main:document-tag', id: id, }))),
      ],
    }),

    addDocumentTag: build.mutation<string, RtkqRequest<CreateDocumentTagRequest>>({
      queryFn: rtkq.axios((args) => Http.post<string>(`/api/document-tag`, args)),
      invalidatesTags: (_1, _2) => [{ type: 'main:document-tag', id: 'list' }],
    }),

    updateDocumentTag: build.mutation<void, RtkqRequest<UpdateDocumentTagRequest>>({
      queryFn: rtkq.axios((args) => Http.put(`/api/document-tag/${args.id}`, args)),
      invalidatesTags: (_1, _2, { id }) => [{ type: 'main:document-tag', id: id }],
    }),

    deleteDocumentTag: build.mutation<void, RtkqRequest<{ id: string }>>({
      queryFn: rtkq.axios(({ id }) => Http.delete<void>(`/api/document-tag/${id}`)),
      invalidatesTags: (_1, _2, { id }) => [{ type: 'main:document-tag', id }],
    }),
  }),
});

export const {
  useAddDocumentTagMutation,
  useUpdateDocumentTagMutation,
  useDeleteDocumentTagMutation,
  useGetDocumentTagListQuery,
  useLazyGetDocumentTagListQuery,
} = documentTagsApi;
